





















































import VueOptions from '@utils/VueOptions'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RecapResourceListItem'

  vue:
    props: ['item', 'actions']

    computed:
      listing: ->
        @item.ctx.listing

      brandInfo: ->
        @ctxCampaign(@item).brand_info || {}

      status: ->
        statuses =
          not_started:
            label: 'Not Started'
            style: 'text-yellow-dark'
            borderStyle: 'border-yellow-dark'
            badgeStyle: 'bg-yellow-dark text-white'
            # iconClass: 'fas fa-comment-dots'
          started:
            label: 'Started'
            style: 'text-white'
            borderStyle: 'border-orange'
            badgeStyle: 'bg-orange text-white'
            # iconClass: 'fas fa-rocket'
          completed:
            label: 'Completed'
            style: 'text-green'
            borderStyle: 'border-white'
            badgeStyle: 'bg-green text-white'
            # iconClass: 'far fa-check'
        statuses[@item.status] || statuses['not_started']

      photos: ->
        @uniq [...@item.published_photos, ...@item.photos]

      totalPhotos: ->
        @item.photos.length - @item.photos_invalid.length

      totalAnswers: ->
        answers = RecapUtility.requiredAnswers @item
        Object.keys(answers).length

      totalRequiredQuestions: ->
        questions = RecapUtility.requiredQuestions @item
        Object.keys(questions).length

export default VueOptions.vue settings
